'use client';

import { TagLabel } from './Label';
import { TagRoot } from './Root';

const Base = TagRoot;

export const Tag = Object.assign(Base, {
  Root: TagRoot,
  Label: TagLabel,
});

export default Tag;
